require('./styles.css');
import React from 'react';

export class Intro extends React.Component {
  render () {
    return (
      <div className="intro">
        <p>Development and strategy.</p>
        <p><a href="mailto:info@idlehands.be">Talk to us</a> or scroll down for our portfolio.</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/intro/index.js